import { Link } from "react-router-dom";
import { ArrowRight, ArrowUpRight, Check } from "lucide-react";
import { useApi, img } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { ZoomWrap } from "@/components/site/Reveal";

export const CortezHighlight = () => {
  const { t, L, to } = useLang();
  const { data } = useApi("/places/cortez-estates");
  const p = data?.place;
  if (!p) return null;
  return (
    <article className="flex h-full flex-col overflow-hidden rounded-2xl bg-forest text-white" data-testid="home-cortez-card">
      <Link to={to("/areas/cortez-estates")} className="img-zoom block aspect-[4/3] overflow-hidden" data-testid="home-cortez-image-link">
        <ZoomWrap className="h-full"><img src={img(p.cover_image)} alt={L(p, "name")} loading="lazy" className="h-full w-full object-cover" /></ZoomWrap>
      </Link>
      <div className="flex flex-1 flex-col p-7">
        <p className="text-xs font-bold uppercase tracking-wider text-white/70">{t("home.cortezEyebrow")}</p>
        <h3 className="mt-2 font-display text-3xl font-black">{L(p, "name")}</h3>
        <ul className="mt-4 space-y-2 text-sm font-semibold text-white/90" data-testid="home-cortez-points">
          {(L(p, "highlights") ? L(p, "highlights").split("\n").map((s) => s.trim()).filter(Boolean) : t("home.cortezPoints")).map((pt) => <li key={pt} className="flex gap-2"><Check className="mt-0.5 h-4 w-4 shrink-0" />{pt}</li>)}
        </ul>
        <div className="mt-auto flex flex-wrap gap-3 pt-7">
          <Link to={to("/areas/cortez-estates")} className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-bold text-forest transition-transform duration-200 hover:-translate-y-0.5" data-testid="home-cortez-explore">{t("home.cortezCta")} <ArrowRight className="h-4 w-4" /></Link>
          <a href={p.cta_url} target="_blank" rel="noopener" className="inline-flex items-center gap-1.5 px-1 py-2.5 text-sm font-bold text-white underline-offset-4 hover:underline" data-testid="home-cortez-lots">{t("home.cortezLots")} <ArrowUpRight className="h-4 w-4" /></a>
        </div>
      </div>
    </article>
  );
};
